import { initSummernote } from '../../summernote';
import { initScheduleDate } from '../../schedule_date';
import { buildScheduleForm } from './build_schedule_form';
import { toggleFormRow } from './toggle_form_row';

export function initScheduleButtonListeners(insertedCellColSpan: number) {
  const wrapper = document.getElementById('candidates-table');
  if (!wrapper) return;

  wrapper.addEventListener('click', async (e: any) => {
    const target = e.target.closest('.schedule-button');
    if (!target) {
      return;
    }

    e.preventDefault();
    e.stopPropagation(); // prevent bootstrap from firing toggle-event twice

    const row = target.closest('tr.gridjs-tr');
    if (!row) {
      return;
    }

    const scheduleFormRow = row.nextElementSibling;
    if (scheduleFormRow && scheduleFormRow.classList.contains('all-candidates-schedule-form')) {
      const scheduleCell = scheduleFormRow.querySelector('td');
      if (scheduleCell && scheduleCell.style.display !== 'none') {
        toggleFormRow(target, scheduleCell);
        scheduleFormRow.remove(); // remove existing schedule form for force-refetching on reopen
        return;
      }
    }

    const botsProspectId = row.querySelector('[data-bots-prospect-id]')?.getAttribute('data-bots-prospect-id');
    const botId = row.querySelector('[data-bot-id]')?.getAttribute('data-bot-id');
    if (!botsProspectId || !botId) {
      alert(botsProspectId ? 'Bot ID not found' : 'ID not found');
      return;
    }

    try {
      // disable trigger-button
      target.style.pointerEvents = 'none';
      target.style.opacity = '0.5';

      // start fetching schedule-contact
      const requestPath = `/bots/${botId}/prospects/${botsProspectId}/schedule_contact`;
      const response = await fetch(requestPath, {
        headers: {
          'Accept': 'application/json'
        }
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // render new row with summernote beneath the current row
      const data = await response.json();
      const newRow = document.createElement('tr');
      const newCell = document.createElement('td');
      const noteForm = buildScheduleForm(data.form_action, data.email_chain_id, data.date, data.subject, data.body);
      newCell.colSpan = insertedCellColSpan;
      newCell.appendChild(noteForm);
      newRow.appendChild(newCell);
      newRow.classList.add('all-candidates-schedule-form');
      newCell.style.display = 'none';
      row.after(newRow);
      toggleFormRow(target, newCell);
      initSummernote();
      initScheduleDate();
    } catch (error) {
      console.log(error);
      alert("Failed to load note form");
    } finally {
      // re-enable trigger-button
      target.style.pointerEvents = 'auto';
      target.style.opacity = '1';
    }
  });
}
